<template>
    <component :is="template">
        <div v-if="ready && order">
            <div class="contents-area">
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">주문결과</h2>
                </div>
                <div class="contents-area__inner">
                    <section class="page-section pt-0">
                        <v-data-table v-if="resCode == '3001'" :items="purchases" :headers="purchasesHeaders" disable-pagination disable-sort hide-default-footer mobile-breakpoint="768" width="100%" class="d-flex purchasedetail-table">
                            <template slot="item.product" slot-scope="{item}">
                                <div class="img-wrap border">
                                    <router-link :to="`/shop/products/${item.product._mainProduct || item.product._id}`">
                                        <v-img :src="item?.product?.thumb" width="100" :aspect-ratio="1/1" contain position="center" class="mx-auto" />
                                    </router-link>
                                </div>
                            </template>
                            <v-responsive slot="item.name" slot-scope="{item}">
                                <v-flex>
                                    <router-link :to="`/shop/products/${item.product._mainProduct || item.product._id}`">
                                        <div>{{ item?.product?.name}}</div>
                                    </router-link>
                                </v-flex>
                            </v-responsive>
                            <v-responsive slot="item.saleAmount" slot-scope="{item}">
                                <v-flex>
                                    <div class="mx-2 text-truncate">{{ item.saleAmount.format() }}원</div>
                                </v-flex>
                            </v-responsive>
                            <v-responsive slot="item.earnPointAmount" slot-scope="{item}">
                                <v-flex>
                                    <div class="mx-2 text-truncate">{{ item.earnPointAmount.format() }}원</div>
                                </v-flex>
                            </v-responsive>
                        </v-data-table>
                        <div v-else>
                            <div>[{{ resCode }}]</div>
                            <div>결제가 완료되지 않았습니다</div>
                        </div>
                    </section>

                    <section class="page-section py-0">
                        <div class="card--primary">
                            <v-row align="center" justify="center" class="row--x-small font-size-14 font-size-md-16">
                                <v-col cols="auto">
                                    <span>상품(<b>{{ order?.saleAmount.format() }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">+</v-col>
                                <v-col cols="auto">
                                    <span>배송비(<b>{{ order?.shippingAmount.format() }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">+</v-col>
                                <v-col cols="auto">
                                    <span>도서산간 할증(<b>{{ order?.islandAmount.format() }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">-</v-col>
                                <v-col cols="auto">
                                    <span>적립금 사용(<b>{{ order?.pointAmount.format() }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">-</v-col>
                                <v-col cols="auto">
                                    <span>캐시 사용(<b>{{ order?.cashAmount.format() }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">=</v-col>
                                <v-col cols="auto">
                                    <div class="d-flex align-center">
                                        <span>총 결제 금액</span><b class="font-size-20 font-size-md-24 ml-10px ml-md-12px">{{ totalAmount.format() }}원</b>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </section>

                    <section class="page-section">
                        <table class="table--default">
                            <colgroup>
                                <col style="width:20%">
                                <col style="width:30%">
                                <col style="width:20%">
                                <col style="width:30%">
                            </colgroup>
                            <tr>
                                <th>주문번호</th>
                                <td>{{order?.orderNo}}</td>
                                <th>주문일</th>
                                <td>{{order?.createdAt.toDate()}}</td>
                            </tr>
                            <tr>
                                <th>결제방법</th>
                                <td>{{paymentWay}}</td>
                                <th>주문상태</th>
                                <td v-if="resCode !== '3001'">{{'-'}}</td>
                                <td v-if="resCode === '3001'">{{order?.purchases[0].paymentStatus}}</td>
                            </tr>
                            <tr>
                                <th>입금자명</th>
                                <td colspan="3">{{order?.buyer?.name}}</td>
                            </tr>
                        </table>
                    </section>

                    <section class="page-section pb-0">
                        <div class="tit-wrap mb-10px mb-md-20px">
                            <h3 class="tit tit--xs">주문하신 분</h3>
                        </div>
                        <table class="table--default">
                            <colgroup>
                                <col style="width:20%">
                                <col style="width:80%">
                            </colgroup>
                            <tr>
                                <th>주문하신분</th>
                                <td>{{order?.buyer?.name}}</td>
                            </tr>
                            <tr>
                                <th>연락처</th>
                                <td>{{order?.buyer?.phone}}</td>
                            </tr>
                            <tr>
                                <th>이메일</th>
                                <td>{{order?.buyer?.email}}</td>
                            </tr>
                            <tr>
                                <th>주소</th>
                                <td>{{`[${order?.shippingAddress?.postcode}] ${order?.shippingAddress?.address1} ${order?.shippingAddress?.address2}`}}</td>
                            </tr>
                            <tr>
                                <th>받는사람 연락처</th>
                                <td>{{order?.receiver?.phone}}</td>
                            </tr>
                        </table>
                    </section>

                    <div class="mt-20px mt-md-30px">
                        <v-row align="center" justify="center" class="row--x-small">
                            <v-col cols="auto">
                                <v-btn large outlined color="gray" to="/"><span class="grey--text text--darken-3">홈으로가기</span></v-btn>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn large color="primary" to="/mypage/shop/purchases">주문배송확인</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
        </div>

        <daum-postcode ref="daumPostcode" @input="({ postcode, address }) => { order.shippingAddress.postcode = postcode; order.shippingAddress.address1 = address; } " />
        <!-- <kcp-pay ref="kcpPay" /> -->
    </component>
</template>
<script>
import api from "@/api";
import { mdiReceipt, mdiBookOpenPageVariant  } from "@mdi/js";
import PickupItem from "@/components/client/shop/order/pickup-item.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import KcpPay from "@/components/plugins/kcp/kcp-pay.vue";
export default {
    components: {
        PickupItem,
        DaumPostcode,
        KcpPay
    },
    data(){
        return {
            mdiReceipt,
            mdiBookOpenPageVariant,

            ready: false,
            order: null,
            purchases: null,

            resCode: this.$route.query.resCode,
            resMessage: this.$route.query.resMessage,

            purchasesHeaders: [
                { text: "이미지", value: "product", align: "center", width: "14%" },
                { text: "구매상품정보", value: "name", align: "center", width: "auto" },
                { text: "제품가격", value: "saleAmount", align: "center", width: "14%" },
                { text: "적립금", value: "earnPointAmount", align: "center", width: "14%" },
                { text: "구매수량", value: "quantity", align: "center", width: "14%" }
            ]
        }
    },
    async mounted(){
        await this.init();
    },
    methods: {
        async init(){
            // 상품페이지 & 장바구니에서 픽업된 상품 로드
            let { order } = await api.v1.me.shop.orders.get({ _id: this.$route.query._order });

            this.order = order;
            this.purchases = order.purchases
            console.log(order, this.purchases)
            this.ready = true;
        },
        open(url){
            window.open(`https://daehanbooks.co.kr/${url}`)
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.shop}`); },
        totalAmount(){
            return this.order?.saleAmount + this.order?.shippingAmount + this.order?.islandAmount - this.order?.pointAmount - this.order?.cashAmount
        },
        paymentWay(){
            let str = ""
            if(this.order.cashAmount && this.order.pointAmount && !this.order.paymentAmount) str =  '캐시 & 포인트 결제'
            if(this.order.cashAmount && !this.order.pointAmount && !this.order.paymentAmount) str =  '캐시 결제'
            if(!this.order.cashAmount && this.order.pointAmount && !this.order.paymentAmount) str =  '포인트 결제'
            if(!this.order.cashAmount && !this.order.pointAmount && this.order.paymentAmount) str =  '신용카드 결제'
            if(!this.order.cashAmount && this.order.pointAmount && this.order.paymentAmount) str =  '신용카드 & 포인트 결제'
            if(this.order.cashAmount && !this.order.pointAmount && this.order.paymentAmount) str =  '신용카드 & 캐시 결제'
            if(this.order.cashAmount && this.order.pointAmount && this.order.paymentAmount) str =  '신용카드 & 캐시 & 포인트 결제'
            return str
        },
    },
}
</script>

<style scoped>
.row + .row {
    margin-top: 0px;
}
.v-input >>> .v-input__slot:before {
    border: 0 !important;
}
</style>